<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建广告主</el-button>
        </li>
        <li>
          <el-button type="primary" size="small" @click="myOption.restStartPage();getList();">刷新</el-button>
        </li>
        <li>
          <span>广告主名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryName" @input="getList"></el-input>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="advertiserName" label="名称" min-width="150px" fixed="left"></el-table-column>
        <el-table-column prop="advertiserId" label="ID" min-width="150px" fixed="left"></el-table-column>
        <el-table-column prop="balance" label="账户余额" min-width="150px"></el-table-column>
        <el-table-column label="是否允许透支" min-width="150px">
          <span slot-scope="scope">{{scope.row.overdraft === 1 ? '是' : '否'}}</span>
        </el-table-column>
        <el-table-column prop="modifier" label="修改人" min-width="150px"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" min-width="180px"></el-table-column>
        <el-table-column prop="remark" label="描述" min-width="200px"></el-table-column>
        <el-table-column v-if="deletePower || modifyPower" label="操作" min-width="220px">
          <template slot-scope="scope">
            <el-button v-if="balancePower" type="text" size="small" @click="rechargeAndRefund(tableData[scope.$index], 1)">充值</el-button>
            <el-button v-if="balancePower" :disabled="scope.row.balance <= 0" type="text" size="small" @click="rechargeAndRefund(tableData[scope.$index], 2)">退款</el-button>
            <el-button v-if="balanceDetailPower" type="text" size="small" @click="rechargeAndRefundRecord(tableData[scope.$index])">记录</el-button>
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
    <el-dialog :title="dialogForm.type === 1 ? '充值' : '退款'" :visible.sync="dialogVisible" width="420px" :before-close="dialogRest">
      <el-form :model="dialogForm">
        <el-form-item label="广告主：" label-width="90px">
          <span>{{dialogForm.advertiserName}}</span>
        </el-form-item>
        <el-form-item label="账户余额：" label-width="90px">
          <span>{{dialogForm.oldBalance}}</span>
        </el-form-item>
        <el-form-item :label="`${dialogForm.type === 1 ? '充值' : '退款'}金额：`" label-width="90px" :error="dialogBalanceTips">
          <el-input type="text" v-model="dialogForm.balance" style="width: 270px" @input="balance"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRest">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: false,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      balancePower: false,
      balanceDetailPower: false,
      queryName: '',
      dialogVisible: false,
      dialogBalanceTips: '',
      dialogForm: {
        advertiserId: '',
        advertiserName: '',
        oldBalance: '',
        type: '',
        balance: ''
      }
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.user.children.adOwner.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[1300].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 充值/修改
      if ((power & thisModule.balance.power) === thisModule.balance.power) {
        this.balancePower = true
      }
      // 充值/修改记录
      if ((power & thisModule.balanceDetail.power) === thisModule.balanceDetail.power) {
        this.balanceDetailPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 判断临时缓存是否存在
    this.myOption.getScreenData(this, 'screen-adowner')
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify({
          advertiserName: this.queryName,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.tableData = res.data.data.data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.advertiserId, copy: false})
      }
      let param = {}
      if (this.queryName !== '') {
        param.queryName = this.queryName
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-adowner', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.advertiserName}" 广告主`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            advertiserIds: param.advertiserId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除广告主成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 充值/退款
    rechargeAndRefund (data, type) {
      this.dialogForm.advertiserId = data.advertiserId
      this.dialogForm.advertiserName = data.advertiserName
      this.dialogForm.type = type
      this.dialogForm.oldBalance = data.balance
      this.dialogVisible = true
    },
    // 金额验证
    balance (val) {
      if (val && !(/^([1-9]\d{0,8}|0)([.]?|(\.\d{1,2})?)$/.test(val))) {
        let arr = val.replace(/[^\d^.]/g, '').split('.')
        if (arr[0]) {
          if ((arr[0] * 1 === 0 || arr[0][0] * 1 === 0) && arr[0].length > 1) {
            arr[0] = 0
          } else if (this.dialogForm.type * 1 === 1 && arr[0].length >= 9) {
            arr[0] = arr[0].substring(0, 9)
          }
          if (arr[1] && arr[1].length > 2) {
            arr[1] = arr[1].substring(0, 2)
          }
          this.dialogForm.balance = `${arr[0]}${arr[1] ? '.' + arr[1] : ''}`
        }
      }
      if (this.dialogForm.type * 1 === 2) {
        if (this.dialogForm.oldBalance * 1 < this.dialogForm.balance * 1) {
          this.dialogForm.balance = this.dialogForm.oldBalance
        }
      }
      this.dialogBalanceTips = ''
    },
    // 充值/退款请求
    dialogSubmit () {
      const typeText = this.dialogForm.type === 1 ? '充值' : '退款'
      if (!this.dialogForm.balance) {
        this.dialogBalanceTips = `${typeText}金额为必填`
        return false
      } else if (this.dialogForm.balance * 1 === 0) {
        this.dialogBalanceTips = `${typeText}金额必须大于0`
        return false
      } if (this.dialogBalanceTips) {
        return false
      } else {
        this.dialogBalanceTips = ''
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.balance.id
        },
        url: this.myOption.requestUrl + this.thisModule.balance.api,
        data: this.qs.stringify({
          advertiserId: this.dialogForm.advertiserId,
          type: this.dialogForm.type,
          balance: this.dialogForm.balance
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.$message.success(`${typeText}成功`)
          this.dialogRest()
          this.getList()
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 清空表单
    dialogRest () {
      this.dialogForm.advertiserId = ''
      this.dialogForm.advertiserName = ''
      this.dialogForm.type = ''
      this.dialogForm.oldBalance = ''
      this.dialogForm.balance = ''
      this.dialogBalanceTips = ''
      this.dialogVisible = false
    },
    // 充值/退款记录
    rechargeAndRefundRecord (data) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.advertiserId, copy: false})
      }
      this.$router.push({
        path: this.$route.path.replace('/list', '/record')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ad_owner/List.vue